module.exports = __webpack_public_path__ + "static/media/logo-header.61db520d.svg";